// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7447":"8dc32350","8998":"3b53517f","9575":"3b53517f"}[chunkId] + ".chunk.css";
};